import { MainButtonProps } from '@/components/ui/custom/buttons/MainButton';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import SectionFilterFactory from '@/components/projects/carousel/filters/ProjectFilterFactory';
import { ProjectsSections } from '@/components/projects/carousel/ProjectCarousel';
import { ProjectFilters } from '@/data/services/projectServices';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

export type ProjectSectionHeaderProps = {
  section?: ProjectsSections;
  hiddenFilter?: boolean;
  title?: string;
  filters?: ProjectFilters;
  onFilter?: (filters: ProjectFilters) => void;
  button: React.ReactElement<MainButtonProps>;
  className?: Pick<ClassNameComponent, 'title'>;
};

export default function ProjectSectionHeader({
  section = 'recents',
  filters,
  hiddenFilter,
  title,
  onFilter,
  className,
  button,
}: ProjectSectionHeaderProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'projects.page' });

  return (
    <div className="relative flex justify-between w-full gap-2.5  items-center">
      <div className="flex gap-x-2 gap-y-1 flex-wrap items-center">
        <Text
          format="rubik-500"
          size="text-18"
          text={title || t(section)}
          className={twMerge('text-accent', className?.title)}
        />
        <ConditionalRenderer condition={!hiddenFilter}>
          <SectionFilterFactory
            filter={filters}
            onFilter={onFilter}
            section={section}
          />
        </ConditionalRenderer>
      </div>
      {button}
    </div>
  );
}
